export default __webpack_public_path__ + "static/media/loggage.4e730b6f.svg";